import { env } from "@/next.config";
import httpUtils from "@/utils/httpUtils";

export async function submitGuideRequest(payload) {
  return await httpUtils.post(`${env.API_VERSION}/guide-request`, payload);
}
